import { useState } from "react";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
function useApiPost() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [payloadData,setPayloadData] = useState(null);

    const Postdata = (url, auth, payload) => {
        setPayloadData(payload);
        let token = `Bearer ${localStorage.getItem('ACCESS')}`

        const headerData = {
            // "Content-Type":payload instanceof FormData ? "multipart/form-data" : "",
            "Authorization": auth ? token : "",
        }

        if (!(payload instanceof FormData)) {
            headerData["Content-Type"] = "application/json"
        }


        // console.log(payload instanceof FormData);
        setLoading(true);
        setError(null);
        fetch(url, {
            method: "POST",
            headers: headerData,
            body: payload instanceof FormData ? payload : JSON.stringify(payload)
        })
            .then((r) => r.json().then((data) => ({ status: r.status, body: data })).catch((e) => console.log(e)))
            .then((result) => {
                //console.logresult.status)

                if (result.status === 200) {
                    setData(result);
                }
                if (result.status === 401 || result.status === 403 || result.status === 404) {
                    setError(result)
                }
                if (result.status === 400) {
                    //console.log'comming into the rro')
                    setError(result)
                }
                if (result.status === 405) {

                }

                if (result.status === 500) {

                }
            })
            .catch((err) => {
                console.log(err);
                toast.warning('Something went wrong, Try again', {
                    position: "top-center",
                });
                toast.clearWaitingQueue();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return { data, loading, error, Postdata, setData, setLoading, setError,payloadData };
}

export default useApiPost;
